import { render, staticRenderFns } from "./AllocateMpesaPayments.vue?vue&type=template&id=3d2c1cc0&"
import script from "./AllocateMpesaPayments.vue?vue&type=script&lang=js&"
export * from "./AllocateMpesaPayments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports